import _ from 'lodash';
import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Dropdown } from '@bibliocommons/base-dropdown';

import './SearchTypeDropdown.scss';

class SearchTypeDropdown extends BcReactComponent {
  getOptions() {
    const options = _.map(this.props.options, option => ({
      label: <FormattedMessage id={`Search.searchTypes.${option}`} />,
      value: option
    }));
    return options;
  }

  getSelected() {
    return (
      <FormattedMessage id={`Search.searchTypes.${this.props.selected}`} />
    );
  }

  static getAriaLabel() {
    return (
      <FormattedMessage id="searchTypeDropdownLabel" />
    );
  }

  render() {
    const { handleSelect, className } = this.props;
    const labelledById = _.uniqueId('searchTypeDropdown_');

    return (
      <div className="cp-search-type-dropdown" data-test-id="searchType">
        <Dropdown
          selected={this.getSelected()}
          className={cn('btn dropdown-toggle btn-flat btn-default', className)}
          options={this.getOptions()}
          handleSelect={handleSelect}
          labelledById={labelledById}
          labelLocalizedText={SearchTypeDropdown.getAriaLabel()} />
      </div>
    );
  }
}

SearchTypeDropdown.propTypes = {
  selected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  handleSelect: PropTypes.func,
  className: PropTypes.string
};

export default SearchTypeDropdown;



// WEBPACK FOOTER //
// ./app/components/search/SearchTypeDropdown/SearchTypeDropdown.jsx